const PARSER_DOMAIN = 'parser'

const PARSER_STATE = {
  data: {}
}

export {
  PARSER_DOMAIN,
  PARSER_STATE
}
